import { RefObject, useEffect } from 'react';
import styles from './WizardHeaderStepConnector.module.scss';

export function WizardHeaderStepConnector({
  wizardHeaderStepRef
}: {
  wizardHeaderStepRef: RefObject<HTMLDivElement>;
}) {
  useEffect(() => {
    if (wizardHeaderStepRef.current) {
      const container = wizardHeaderStepRef.current;
      const children = container.querySelectorAll('.wizard-header-step');

      const containerRect = container.getBoundingClientRect();

      children.forEach((child, index) => {
        if (index < children.length - 1) {
          const firstCircle = child.querySelector('.wizard-header-step-progress');
          const secondCircle = children[index + 1].querySelector('.wizard-header-step-progress');

          const line = document.createElement('div');
          line.className = styles.wizardStepConnector;
          container.appendChild(line);

          if (firstCircle && secondCircle) {
            const firstCircleRect = firstCircle.getBoundingClientRect();
            const secondCircleRect = secondCircle.getBoundingClientRect();

            const lineStart = firstCircleRect.right - containerRect.left;
            const lineEnd = secondCircleRect.left - containerRect.left;
            const lineWidth = lineEnd - lineStart;

            line.style.left = `${lineStart}px`;
            line.style.width = `${lineWidth}px`;
          }
        }
      });
    }
  }, []);

  return null;
}
